import { render } from "./PdfImageRow.vue?vue&type=template&id=287198ea&scoped=true&ts=true"
import script from "./PdfImageRow.vue?vue&type=script&lang=ts"
export * from "./PdfImageRow.vue?vue&type=script&lang=ts"

import "./PdfImageRow.vue?vue&type=style&index=0&id=287198ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287198ea"]])

export default __exports__